// @ts-nocheck
export default function Ads(props: any) {
  const { slot, style, client = "ca-pub-8823204853280729", className = "adsbygoogle" } = props;
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      console.log("ads广告代码执行了:", slot);
      return () => {};
    } catch (error) {}
  }, []);
  return (
    <div style={{ textAlign: "center" }} className="google-ad-container">
      <ins className={className} style={style} data-ad-client={client} data-ad-slot={slot}></ins>
    </div>
  );
}
